import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_6: FaireProductEntity = {
  token: "beverage-6",
  type: "product",
  name: "Matcha Green Tea Powder",
  brandName: "Tea Leaf Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3e91bd133da97249615f4e7b28d4749bdb811474cb26606fcdacc5e617f253e7.webp",
  priceDollars: 24,
  msrpDollars: 38,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
